import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchLeaderboard } from '../../api/backend';
import { useAuth } from '../../context/AuthContext';
import DashNav from '../Dashboard/DashNav';
import '../Dashboard/GameDashboard.css';
import './LeaderboardPage.css';

// Top 25 wheel players by high score, shown by gamertag (masked email when a
// player hasn't set one). Rendered inside the SAME popup shell as the
// Account Dash (container, header ✕, bottom Close, homepage link) so
// switching between the two feels like changing pages, not popups.
const LeaderboardPage = () => {
  const navigate = useNavigate();
  const { account } = useAuth();
  const [rows, setRows] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetchLeaderboard()
      .then((data) => {
        if (!cancelled) {
          setRows(Array.isArray(data.leaderboard) ? data.leaderboard : []);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setError('Could not load the leaderboard. Please try again.');
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const myTag = account?.gamerTag || null;

  return (
    <div className="game-dashboard">
      <div className="game-dashboard__container">
        <div className="game-dashboard__header">
          <h1 className="game-dashboard__title">Leaderboard</h1>
          <button
            onClick={() => navigate('/game')}
            className="game-dashboard__close"
            aria-label="Close"
          >
            ✕
          </button>
        </div>

        <div className="game-dashboard__stat-card">
          <div className="game-dashboard__stat-label">Top 25 · High Scores</div>

          {error && <div className="leaderboard-page__empty">{error}</div>}
          {!error && rows === null && (
            <div className="leaderboard-page__empty">Loading…</div>
          )}
          {!error && rows !== null && rows.length === 0 && (
            <div className="leaderboard-page__empty">
              No scores on the board yet — be the first! Play a game and claim the top spot.
            </div>
          )}

          {!error && rows && rows.length > 0 && (
            <div className="leaderboard-page__table">
              <div className="leaderboard-page__row leaderboard-page__row--head">
                <span className="leaderboard-page__rank">#</span>
                <span className="leaderboard-page__player" />
                <span className="leaderboard-page__score">HIGH SCORE</span>
              </div>
              {rows.map((row) => (
                <div
                  key={row.rank}
                  className={
                    myTag && row.player === myTag
                      ? 'leaderboard-page__row leaderboard-page__row--me'
                      : 'leaderboard-page__row'
                  }
                >
                  <span className="leaderboard-page__rank">
                    {row.rank <= 3 ? ['🥇', '🥈', '🥉'][row.rank - 1] : row.rank}
                  </span>
                  <span className="leaderboard-page__player" title={row.player}>
                    {row.player}
                  </span>
                  <span className="leaderboard-page__score">
                    {(row.highScore ?? 0).toLocaleString()}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>

        <DashNav />

        <button className="game-dashboard__bottom-close" onClick={() => navigate('/game')}>
          Close
        </button>
        <a
          className="game-dashboard__home-link"
          href="https://www.satoshiadvance.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Visit SatoshiAdvance.com
        </a>
      </div>
    </div>
  );
};

export default LeaderboardPage;
